import { Component } from '@angular/core';

import { RouterLink } from '@angular/router';

export interface Partner {
  name: string;
  avatar: string;
  url: string;
  platform: string;
}

@Component({
  selector: 'app-social-partners',
  imports: [RouterLink],
  templateUrl: './social-partners.component.html',
  styleUrl: './social-partners.component.scss',
})
export class SocialPartnersComponent {
  partners: Partner[] = [
    {
      name: '@itscamillarinaldi',
      avatar: 'assets/partner/partner4.jpg',
      url: 'https://www.instagram.com/itscamillarinaldi/',
      platform: 'Instagram',
    },
    {
      name: '@_artistry.ai',
      avatar: 'assets/partner/partner1.jpg',
      url: 'https://www.instagram.com/_artistry.ai',
      platform: 'Instagram',
    },
    {
      name: '@lanfe.n',
      avatar: 'assets/partner/partner2.jpg',
      url: 'https://www.instagram.com/lanfe.n',
      platform: 'Instagram',
    },
    {
      name: '@miarayxb',
      avatar: 'assets/partner/partner3.jpg',
      url: 'https://www.instagram.com/miarayxb/',
      platform: 'Instagram',
    },
    {
      name: '@april_mcdon',
      avatar: 'assets/partner/partner5.jpg',
      url: 'https://www.instagram.com/april_mcdon/',
      platform: 'Instagram',
    },
  ];

  openPartnerProfile(partner: Partner) {
    window.open(partner.url, '_blank', 'noopener,noreferrer');
  }
}
